import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../http/base-api.service';
import { ROLE_ENDPOINTS, USER_ENDPOINTS, ADHOC_ENDPOINTS } from '@packages/shared-types';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private api: BaseApiService) {}

  getUserTypes(programId: number): Observable<any> {
    // Updated to use enrollment-onboarding/get-user-types endpoint
    return this.api.get(`${ADHOC_ENDPOINTS.getUserTypes}`, { program_id: programId });
  }

  getUserGroupsByRole(roleId: number): Observable<any> {
    return this.api.get(`${USER_ENDPOINTS.GET_GEO_GROUPS_BY_ROLE}`, {
      role_id: roleId,
      program_id: 1,
    });
  }
}
